<template>
  <div>
    <div class="ui form">
      <div class="fields">
        <div class="four wide field" style="padding-top:25px;">
          <label>{{ $t("components.historicalOperation.Fecha_inicio") }}</label>
          <div class="ui calendar" id="fecha-inicio">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text">
            </div>
          </div>
        </div>
        <div class="four wide field" style="padding-top:25px;">
          <label>{{ $t("components.historicalOperation.Fecha_fin") }}</label>
          <div class="ui calendar" id="fecha-fin">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text">
            </div>
          </div>
        </div>
        <div class="eight wide field" style="padding-top:25px;">
          <label>{{ $t("components.historicalOperation.Dispositivo") }}</label>
          <div class="ui action input">
            <select class="ui dropdown fluid" v-model="currentTerminalSelected" @change="refresh">
              <option value="0">{{ $t('components.historicalOperation.Todos') }}</option>
              <option v-bind:value="controller._id" v-bind:key="controller._id" v-for="controller in allControllers">
                {{ controller.description }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <h3 class="ui dividing header" style="margin-top: 0px"></h3>
    <table v-if="commandHistoricals.length > 0" id="table-command-historical" class="ui compact celled table selectable sortable">
      <thead class="full-width">
        <tr>
          <th class="four wide">{{ $t("components.historicalOperation.Fecha") }}</th>
          <th class="four wide">{{ $t("components.historicalOperation.Usuario") }}</th>
          <th class="five wide">{{ $t("components.historicalOperation.Dispositivo") }}</th>
          <th class="three wide">{{ $t("components.historicalOperation.Operacion") }}</th>
          <th class="three wide">{{ $t("components.historicalOperation.Resultado") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="commandHistorical in commandHistoricals" v-bind:key="commandHistorical._id">
          <td :class="{ negative : !getResultadoOperacion(commandHistorical) }">{{ (commandHistorical.date != null) ? moment(commandHistorical.date).locale($i18n.locale).format('YYYY/MM/DD HH:mm:ss') : '' }}</td>
          <td :class="{ negative : !getResultadoOperacion(commandHistorical) }">{{ getNombreUsuario(commandHistorical) }}</td>
          <td :class="{ negative : !getResultadoOperacion(commandHistorical) }">{{ getNombreTerminal(commandHistorical) }}</td>
          <td :class="{ negative : !getResultadoOperacion(commandHistorical) }">{{ getTextoOperacion(commandHistorical) }}</td>
          <td class="center aligned" :class="{ negative : !getResultadoOperacion(commandHistorical) }">
            <div class="ui accordion">
              <div class="title ">
                <i class="icon" :class="{ checkmark : getResultadoOperacion(commandHistorical), close: !getResultadoOperacion(commandHistorical) }"></i>
              </div>
              <div class="left aligned content">
                <p class="transition visible center aligned" style="display: block !important;">
                  <strong>{{ getTextoResultadoOperacion(commandHistorical) }}</strong>
                </p>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot class="full-width">
        <tr>
          <th colspan="5">
            <button class="ui olive icon button" data-inverted="" :data-tooltip="$t('components.common.Exportar_excel')" data-position="bottom center" style="float:right" @click="exportTableToExcel">
              <i class="icon file excel large"></i>
            </button>
            <button class="ui olive icon button" data-inverted="" :data-tooltip="$t('components.common.Exportar_pdf')" data-position="bottom center" style="float:right" @click="exportTableToPdf">
              <i class="icon file pdf large"></i>
            </button>
            <button class="ui olive icon button" data-inverted="" :data-tooltip="$t('components.common.Buscar')" data-position="bottom center" style="float:right" @click="refresh">
              <i class="icon sync alternate large"></i>
            </button>
          </th>
        </tr>
      </tfoot>
    </table>
    <div v-if="commandHistoricals.length === 0">
      <div class="ui icon warning message">
        <i class="icon exclamation circle"></i>
        <div class="content">
          <div class="header">
            {{ $t('components.historicalOperation.No_hay_historicos') }}
          </div>
          <p>{{ $t('components.historicalOperation.Seleccione_rango_fechas') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '../utils/axios-general';
import Vue from 'vue';
import JsPDF from 'jspdf';
import 'jspdf-autotable';
import XLSX from 'xlsx';

export default {
  name: 'TableHistoricalOperation',
  data: function () {
    return {
      table: null,
      currentFechaInicio: null,
      currentFechaFin: null,
      currentTerminalSelected: '0',
      allControllers: [],
      commandHistoricals: [],
      moment: Vue.moment,
      initialized: false
    };
  },
  methods: {
    calendarFormatDate: function (date, settings) {
      return this.moment(date).locale(this.$i18n.locale).format('LL');
    },
    onChangeFechaInicio: function (date, text, mode) {
      if (date == null) {
        return false;
      }

      this.currentFechaInicio = date;

      if (this.initialized) {
        Vue.nextTick(() => {
          this.refresh();
        });
      }

      return true;
    },
    onChangeFechaFin: function (date, text, mode) {
      if (date == null) {
        return false;
      }

      this.currentFechaFin = date;

      if (this.initialized) {
        Vue.nextTick(() => {
          this.refresh();
        });
      }

      return true;
    },
    exportTableToPdf: function () {
      const jsPDFInstance = new JsPDF();
      const body = [];

      for(const commandHistorical of this.commandHistoricals) {
        body.push([
          (commandHistorical.date != null) ? this.moment(commandHistorical.date).locale(this.$i18n.locale).format('DD/MM/YYYY HH:mm:ss') : '',
          this.getNombreUsuario(commandHistorical),
          this.getNombreTerminal(commandHistorical),
          this.getTextoOperacion(commandHistorical),
          this.getTextoResultadoOperacion(commandHistorical),
        ]);
      }

      jsPDFInstance.autoTable({
        head: [[
          this.$i18n.t("components.historicalOperation.Fecha"),
          this.$i18n.t("components.historicalOperation.Usuario"),
          this.$i18n.t("components.historicalOperation.Dispositivo"),
          this.$i18n.t("components.historicalOperation.Operacion"),
          this.$i18n.t("components.historicalOperation.Resultado"),
        ]],
        body,
      });

      jsPDFInstance.save(this.$i18n.t('components.historicalOperation.Fichero_export_nombre') + this.moment().locale(this.$i18n.locale).format('YYYYMMDDHHmmss') + '.pdf');
    },
    exportTableToExcel: function () {
      const rows = [[
        this.$i18n.t("components.historicalOperation.Fecha"),
        this.$i18n.t("components.historicalOperation.Usuario"),
        this.$i18n.t("components.historicalOperation.Dispositivo"),
        this.$i18n.t("components.historicalOperation.Operacion"),
        this.$i18n.t("components.historicalOperation.Resultado"),
      ]];

      for(const commandHistorical of this.commandHistoricals) {
        rows.push([
          (commandHistorical.date != null) ? this.moment(commandHistorical.date).locale(this.$i18n.locale).format('DD/MM/YYYY HH:mm:ss') : '',
          this.getNombreUsuario(commandHistorical),
          this.getNombreTerminal(commandHistorical),
          this.getTextoOperacion(commandHistorical),
          this.getTextoResultadoOperacion(commandHistorical),
        ]);
      }

      const worksheet = XLSX.utils.aoa_to_sheet(rows);
      worksheet['!cols'] = [
        {wch:20},
        {wch:40},
        {wch:40},
        {wch:40},
        {wch:20},
      ];
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, this.$i18n.t('components.historicalOperation.Excel_export_nombre_hoja'));
      XLSX.writeFile(workbook, this.$i18n.t('components.historicalOperation.Fichero_export_nombre') + this.moment().locale(this.$i18n.locale).format('YYYYMMDDHHmmss') + '.xlsx');
    },
    refresh: function () {
      axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
      axios.get('/commandhistorical/info').then(response => {
        if (response) {
          this.allControllers = response.data.controllers;

          // comprobamos si hay fecha de inicio
          if (this.currentFechaInicio == null) {
            this.$swal.fire({ type: 'error', title: this.$i18n.t('components.common.Error'), text: this.$i18n.t('components.historicalOperation.Introducir_fecha_inicio') });
            return;
          }

          // comprobamos si hay fecha de fin
          if (this.currentFechaFin == null) {
            this.$swal.fire({ type: 'error', title: this.$i18n.t('components.common.Error'), text: this.$i18n.t('components.historicalOperation.Introducir_fecha_fin') });
            return;
          }

          axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
          axios.get('/commandhistorical?' +
            'fechainicio=' + this.currentFechaInicio.toISOString() +
            '&fechafin=' + this.currentFechaFin.toISOString() +
            ((this.currentTerminalSelected !== '0') ? '&terminal=' + this.currentTerminalSelected : '')
          ).then(response => {
            if (response) {
              if (this.table != null) {
                this.table.destroy();
              }

              this.commandHistoricals = response.data.commandHistoricals;

              setTimeout(() => {
                this.table = $('table').DataTable({
                  destroy: true,
                  order: [[ 0, 'desc' ]],
                  language: this.$i18n.t('components.datatable_language')
                });
              }, 500);

              setTimeout(() => {
                $('.ui.dropdown').dropdown();

                $('#table-command-historical .accordion').accordion({
                  selector: {
                    trigger: '.title'
                  }
                });
              }, 500);
            }
          }).catch((e, a, b, c) => {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.common.Error'),
              text: e
            });
          });
        }
      }).catch((e, a, b, c) => {
        this.$swal.fire({
          type: 'error',
          title: this.$i18n.t('components.common.Error'),
          text: e
        });
      });
    },
    getNombreUsuario: function (historical) {
      if ((historical == null) || (historical.user == null)) {
        return '';
      }

      return historical.user.name + ' (' + historical.user.login + ')';
    },
    getNombreTerminal: function (historical) {
      if ((historical == null) || (historical.controller == null)) {
        return '';
      }

      const controller = this.allControllers.find((c) => c._id === historical.controller);

      if (controller == null) {
        return '';
      }

      return controller.description;
    },
    getTextoOperacion: function (historical) {
      if (historical == null) {
        return '';
      }

      if (this.$i18n.t('components.historicalOperation.Operacion_' + historical.operationType) != null) {
        if (historical.operationType !== 'modoPuerta' && historical.operationType !== 'establecerFecha') {
          return this.$i18n.t('components.historicalOperation.Operacion_' + historical.operationType);
        } else if (historical.operationType === 'establecerFecha') {
          let textoOperacion = this.$i18n.t('components.historicalOperation.Operacion_' + historical.operationType);

          if (historical.operationData != null) {
            textoOperacion += ' (' + historical.operationData + ')';
          }

          return textoOperacion;
        } else if (historical.operationType === 'modoPuerta') {
          let textoOperacion = this.$i18n.t('components.historicalOperation.Operacion_' + historical.operationType);

          if (historical.operationData === '0') {
            textoOperacion += ' (' + this.$i18n.t('components.historicalOperation.Operacion_modoPuerta_cerrada') + ')';
          } else if (historical.operationData === '1') {
            textoOperacion += ' (' + this.$i18n.t('components.historicalOperation.Operacion_modoPuerta_privado') + ')';
          } else if (historical.operationData === '2') {
            textoOperacion += ' (' + this.$i18n.t('components.historicalOperation.Operacion_modoPuerta_a_universidad') + ')';
          } else if (historical.operationData === '3') {
            textoOperacion += ' (' + this.$i18n.t('components.historicalOperation.Operacion_modoPuerta_abierta') + ')';
          } else if (historical.operationData === '4') {
            textoOperacion += ' (' + this.$i18n.t('components.historicalOperation.Operacion_modoPuerta_deshabilitado') + ')';
          }

          return textoOperacion;
        }
      } else {
        return '';
      }
    },
    getResultadoOperacion: function (historical) {
      if (historical == null) {
        return false;
      }

      if (historical.operationResult) {
        return true;
      } else {
        return false;
      }
    },
    getTextoResultadoOperacion: function (historical) {
      if (historical == null) {
        return null;
      }

      if (historical.operationResult) {
        return this.$i18n.t('components.historicalOperation.Operacion_correcta');
      } else if (historical.operationResultData != null) {
        return historical.operationResultData;
      } else {
        return this.$i18n.t('components.historicalOperation.Operacion_error');
      }
    }
  },
  mounted: function () {
    this.currentFechaInicio = new Date();
    this.currentFechaInicio.setHours(0);
    this.currentFechaInicio.setMinutes(0);
    this.currentFechaInicio.setSeconds(0);
    this.currentFechaInicio.setMilliseconds(0);
    this.currentFechaFin = new Date();
    this.currentFechaFin.setHours(23);
    this.currentFechaFin.setMinutes(59);
    this.currentFechaFin.setSeconds(59);
    this.currentFechaFin.setMilliseconds(999);

    this.refresh();

    Vue.nextTick(() => {
      $('#fecha-inicio').calendar({
        type: 'date',
        text: this.$i18n.t('components.common.calendar'),
        ampm: false,
        firstDayOfWeek: 1,
        formatter: {
          date: this.calendarFormatDate
        },
        onChange: this.onChangeFechaInicio
      });

      $('#fecha-fin').calendar({
        type: 'date',
        text: this.$i18n.t('components.common.calendar'),
        ampm: false,
        firstDayOfWeek: 1,
        formatter: {
          date: this.calendarFormatDate
        },
        onChange: this.onChangeFechaFin
      });

      $('#fecha-inicio').calendar('set date', this.currentFechaInicio);
      $('#fecha-fin').calendar('set date', this.currentFechaFin);

      this.initialized = true;
    });

    setTimeout(() => {
      $('.ui.dropdown').dropdown();

      $('#table-command-historical .accordion').accordion({
        selector: {
          trigger: '.title'
        }
      });
    }, 500);
  }
};
</script>
